import { useState } from 'react';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Button, Typography } from '@material-ui/core';

import { setModalStatus } from 'redux/slices/modal.slice';

import { useAcceptNutritionistAppointmentService } from 'features/appointments/services/accept-nutritionist-appointment.service';
import { useRejectNutritionistAppointmentService } from 'features/appointments/services/reject-nutritionist-appointment.service';
import { pendingNutritionistAppointmentSelector } from 'features/appointments/selectors/nutritionist-appointments.selector';

import { useStyles } from './confirm-nutritionist-appointment-modal.styles';

export const ConfirmNutritionistAppointmentModal = () => {
  const [isRejected, setIsRejected] = useState(false);

  const appointment = useSelector(pendingNutritionistAppointmentSelector);

  const { mutate: acceptAppointment, isLoading: isLoadingAccept } =
    useAcceptNutritionistAppointmentService();

  const rejectAppointmentService = useRejectNutritionistAppointmentService();

  const { push } = useHistory();

  const dispatch = useDispatch();

  const classes = useStyles();

  const onAcceptAppointmentHandler = () => {
    acceptAppointment(appointment?._id ?? '');
  };

  const onFirstRejectAppointmentHandler = () => {
    setIsRejected(true);
  };

  const onFinalRejectAppointmentHandler = () => {
    rejectAppointmentService.mutate(appointment?._id ?? '');
  };

  const onRescheduleAppointmentHandler = () => {
    const {
      _id: appointmentId,
      nutritionist: { _id: nutritionistId },
    } = appointment || {};

    dispatch(
      setModalStatus({
        name: 'NUTRITIONIST_APPOINTMENT_CONFIRMATION',
        isActive: false,
      }),
    );

    const url = `/dashboard/main/nutritionist-appointment?mode=reschedule&appointmentId=${appointmentId}&nutritionistId=${nutritionistId}`;

    setTimeout(() => {
      push(url);
    }, 500);
  };

  return (
    <Box textAlign="center">
      {!isRejected && (
        <>
          <Typography variant="h6" className={classes.title}>
            Confirma la consulta de tu nutriólogo
          </Typography>
          <Typography style={{ marginTop: '16px' }}>
            Por favor, confirma la consulta que el nutriólogo agendó para ti.
          </Typography>
          <Typography>
            {format(
              new Date(appointment?.startDate ?? null),
              "EEEE' 'd' de 'LLLL' del 'y' a las 'h:mm aaaa'",
              { locale: es },
            )}
          </Typography>
          <Typography style={{ marginTop: '16px' }}>
            Si tienes alguna duda, comunícate directo con el/ella.
          </Typography>
          <Box
            mt={2}
            display="flex"
            alignItems="center"
            justifyContent="space-evenly"
          >
            <Button
              variant="outlined"
              color="primary"
              onClick={onFirstRejectAppointmentHandler}
              disabled={isLoadingAccept}
            >
              Rechazar
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={onAcceptAppointmentHandler}
              disabled={isLoadingAccept}
            >
              Confirmar
            </Button>
          </Box>
        </>
      )}
      {isRejected && (
        <>
          <Typography variant="h6" className={classes.title}>
            ¿Deseas rechazar o proponer otra fecha?
          </Typography>
          <Typography style={{ marginTop: '16px' }}>
            Si esta fecha no se acomoda, puedes seleccionar otra fecha para no
            perder tu consulta
          </Typography>
          <Box
            mt={2}
            display="flex"
            alignItems="center"
            justifyContent="space-evenly"
          >
            <Button
              variant="outlined"
              color="primary"
              onClick={onFinalRejectAppointmentHandler}
              disabled={rejectAppointmentService.isLoading}
            >
              Rechazar
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={onRescheduleAppointmentHandler}
              disabled={rejectAppointmentService.isLoading}
            >
              Proponer otra fecha
            </Button>
          </Box>
        </>
      )}
    </Box>
  );
};
